import Immutable from 'seamless-immutable'
import {
  COMMON_MODAL_CLOSE,
  COMMON_MODAL_OPEN,
  COMMON_ALERT_CLOSE,
  COMMON_ALERT_OPEN,
  COMMON_NOTIFICATION_CLOSE,
  COMMON_NOTIFICATION_OPEN,
  COMMON_EMAIL_NOTIFICATION_POST,
  COMMON_EMAIL_NOTIFICATION_DISMISS,
  COMMON_EMAIL_NOTIFICATION_FAIL,
  COMMON_EMAIL_NOTIFICATION_SUCCESS,
  COMMON_GET_WP_CONTENT_ATTEMPT,
  COMMON_GET_WP_CONTENT_FAILURE,
  COMMON_GET_WP_CONTENT_SUCCESS,
  COMMON_SCROLL_TO_ELEMENT
} from './actionTypes'

// TODO: Set initial state up different depending on dev / production
const initialState = Immutable({
  modalOpen: false,
  notificationOpen: false,
  notificationPayload: {},
  modalPayload: {},
  wordPressContent: []
})

export default function State(state = initialState, action) {
  switch (action.type) {
    case COMMON_GET_WP_CONTENT_SUCCESS:
      state = state.set('wordPressContent', action.payload)
      break

    // case COMMON_GET_WP_CONTENT_ATTEMPT:
    //   state = state.set("wordPressContent", action.payload);
    //   break;

    case COMMON_MODAL_CLOSE:
      state = state.set('modalOpen', false)
      break

    case COMMON_MODAL_OPEN:
      state = state.set('modalOpen', true)
      state = state.set('modalPayload', action.payload)
      state = state.set('modalTitle', action.payload.title)
      state = state.set('modalComponent', action.payload.component)
      break

    case COMMON_ALERT_CLOSE:
      state = state.set('alertOpen', false)
      break

    case COMMON_ALERT_OPEN:
      state = state.set('alertOpen', true)
      state = state.set('alertType', action.payload.type)
      state = state.set('alertMessage', action.payload.message)
      break

    case COMMON_NOTIFICATION_CLOSE:
      state = state.set('notificationOpen', false)
      break

    case COMMON_NOTIFICATION_OPEN:
      state = state.set('notificationOpen', true)
      state = state.set('notificationPayload', action.payload)
      state = state.set('notificationText', action.payload.message)
      state = state.set('notificationComponent', action.payload.component)
      break
 
    case COMMON_SCROLL_TO_ELEMENT:
      state = state.set('scrollToElement', action.payload)
      break

    case COMMON_EMAIL_NOTIFICATION_POST:
      state = state.set('emailNotificationPost', action.payload)
      break

    case COMMON_EMAIL_NOTIFICATION_DISMISS:
      state = state.set('emailNotificationDismiss', action.payload)
      break

    case COMMON_EMAIL_NOTIFICATION_FAIL:
      state = state.set('emailNotificationFail', action.payload)
      break

    case COMMON_EMAIL_NOTIFICATION_SUCCESS:
      state = state.set('emailNotificationSuccess', action.payload)
      break

    default:
      break
  }

  return state
}
